import React from "react";
import styles from "./Breadcrumb.module.sass";

const shouldShowInsurance = (ibc, personType) => !ibc && personType === "cpf"
const getInsuranceOffset = showInsurance => showInsurance ? 1 : 0
const getActiveStyle = isActive => isActive? styles.active : ""
const getIBCStyle = ibc => ibc ? styles.ibc : ""

function Breadcrumb(props) {
  const showInsurance = shouldShowInsurance(props.ibc, props.personType );
  const insuranceOffset = getInsuranceOffset(showInsurance);
  return (
    <nav data-html2canvas-ignore className={styles.progressBar}>
      <ul className={styles.breadcrumb}>
        <li
          className={[
            styles.item,
            getActiveStyle(props.activeIndex === 1),
            getIBCStyle(props.ibc),
          ].join(" ")}
        >
          <div className={styles.itemContent}>
            <span className={styles.numberNav}>1</span>
            <p className={styles.textNav}>- Oferta</p>
            {props.activeIndex > 1 ? <i className="icon icon-check-p" /> : null}
          </div>
        </li>
        <li
          className={[
            styles.item,
            getActiveStyle(props.activeIndex === 2),
            getIBCStyle(props.ibc),
          ].join(" ")}
        >
          <div className={styles.itemContent}>
            <span className={styles.numberNav}>2</span>
            <p className={styles.textNav}>- Confirmação</p>
            {props.activeIndex > 2 ? <i className="icon icon-check-p" /> : null}
          </div>
        </li>
        <li
          className={[
            styles.item,
            getActiveStyle(props.activeIndex === 3),
            getIBCStyle(props.ibc),
          ].join(" ")}
        >
          <div className={styles.itemContent}>
            <span className={styles.numberNav}>3</span>
            <p className={styles.textNav}>- Preencher dados</p>
            {props.activeIndex > 3 ? <i className="icon icon-check-p" /> : null}
          </div>
        </li>
        {showInsurance && (
          <li
            className={[
              styles.item,
              getActiveStyle(props.activeIndex === 4),
              getIBCStyle(props.ibc),
            ].join(" ")}
          >
            <div className={styles.itemContent}>
              <span className={styles.numberNav}>4</span>
              <p className={styles.textNav}>- Seguro</p>
              {props.activeIndex > 4 ? (
                <i className="icon icon-check-p" />
              ) : null}
            </div>
          </li>
        )}

        <li
          className={[
            styles.item,
            getActiveStyle(props.activeIndex === 5),
            getIBCStyle(props.ibc),
          ].join(" ")}
        >
          <div className={styles.itemContent}>
            <span className={styles.numberNav}>{4 + insuranceOffset}</span>
            <p className={styles.textNav}>- Pagamento</p>
            {props.activeIndex > 5 ? <i className="icon icon-check-p" /> : null}
          </div>
        </li>
        <li
          className={[
            styles.item,
            getActiveStyle(props.activeIndex === 6),
            getIBCStyle(props.ibc),
          ].join(" ")}
        >
          <div className={styles.itemContent}>
            <span className={styles.numberNav}>{5 + insuranceOffset}</span>
            <p className={styles.textNav}>- Finalizar</p>
            {props.activeIndex > 6 ? <i className="icon icon-check-p" /> : null}
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default Breadcrumb;
